<script setup>
import ContactForm from "@/components/contact/ContactForm.vue";

const props = defineProps(["isDialogOpen"]);
const emit = defineEmits(["closeDialog"]);
</script>

<template>
  <v-dialog 
    v-model="props.isDialogOpen" 
    max-width="600"
    scrollable
    :fullscreen="$vuetify.display.xs"
  >
    <div class="dialog-wrapper">
      <ContactForm>
        <template #close>
          <button class="close-btn" @click="emit('closeDialog')" aria-label="Close dialog">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </template>
      </ContactForm>
    </div>
  </v-dialog>
</template>

<style scoped lang="scss">
.dialog-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.05);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #374151;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 600px) {
  .dialog-wrapper {
    padding: 0;
    align-items: flex-start;
  }
  
  .close-btn {
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
